import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  Typography,
} from "@material-ui/core";

import { Email, KeyboardBackspace } from "@mui/icons-material";

import componentStyles from "assets/theme/views/auth/login";
import componentStylesButtons from "assets/theme/components/button";

import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";
import { IsMobile } from "utils/is-mobile";
import InputText from "components/_refactor/text/input";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function AlertError({ text, closeAlert }) {
  return (
    <ReactBSAlert
      error
      style={{ display: "block", marginTop: "-100px" }}
      title="Ops"
      onConfirm={closeAlert}
      onCancel={closeAlert}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

function Alert({ text }) {
  return (
    <ReactBSAlert
      success
      style={{ display: "block", marginTop: "-100px" }}
      title={"Verifique seu e-mail"}
      onConfirm={UtilsFncs.RedirectToLoginPage}
      onCancel={UtilsFncs.RedirectToLoginPage}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

const getForgotPasswordUrl = () => {
  const forgotPasswordPath = `auth/forgot-my-password/`;
  if (window.location.href.includes("karsten-portal-b2b-test")) {
    return process.env.PUBLIC_URL + `/index.html?${forgotPasswordPath}`;
  } else {
    return forgotPasswordPath;
  }
};

export default function ForgotMyPassword() {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
  };
  const location = useLocation();

  const isMobile = IsMobile();

  const [email, setEmail] = useState("");
  const [alert, setalert] = useState(false);
  const [loadingRecover, setLoadingRecover] = useState(false);
  const closeAlert = useCallback(() => setalert(null), []);
  const [backLogin, setBackLogin] = useState(false);

  useEffect(() => {
    const search = location.search;
    const params = new URLSearchParams(search);
    const email = params.get("email");

    if (backLogin) return;

    setEmail(email);

    params.delete("email");

    const newUrl = getForgotPasswordUrl();
    console.log(newUrl);
    window.history.pushState(null, null, newUrl);
  }, [location.search, backLogin]);

  function validateForm() {
    return (
      email?.length > 0 &&
      email?.length <= 200 &&
      MaskAndValid.validateEmail(email)
    );
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setLoadingRecover(true);

    await Api.postParams(
      "generate-password-recovery-token",
      "login",
      "?email=" + email,
      false
    )
      .then(async () => {
        setLoadingRecover(false);
        setalert(
          <Alert text="Instruções de recuperação de senha do portal enviadas." />
        );
      })
      .catch((error) => {
        console.log(error);
        setalert(<AlertError text={error} closeAlert={closeAlert} />);
        setLoadingRecover(false);
      });
  }

  return (
    <>
      {alert}

      <Container
        maxWidth="sm"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Card classes={{ root: classes.card }}>
          <Link
            className={classes.back}
            to={"/login"}
            onClick={() => setBackLogin(true)}
          >
            <KeyboardBackspace onClick={() => setBackLogin(true)} /> Voltar
          </Link>
          <CardContent classes={{ root: classes.cardContent }}>
            <Typography variant="h5" color="textSecondary" align="center">
              Informe seu e-mail de login no campo abaixo para receber
              instruções de recuperação de senha do portal.
            </Typography>

            <form onSubmit={handleSubmit}>
              <FormControl
                variant="filled"
                component={Box}
                width="100%"
                marginBottom="1rem!important"
              >
                  <InputText
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    startAdornment={<Email />}
                    white
                  />
              </FormControl>
              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  variant="contained"
                  style={isMobile ? { width: "100%" } : {}}
                  classes={{ root: classes.buttonContainedInfo }}
                  type="submit"
                  disabled={!validateForm() || loadingRecover}
                >
                  {loadingRecover
                    ? "Enviando instruções por e-mail..."
                    : "Recuperar senha"}
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
